import { render, staticRenderFns } from "./studentWork.vue?vue&type=template&id=116335f2&scoped=true&"
import script from "./studentWork.vue?vue&type=script&lang=js&"
export * from "./studentWork.vue?vue&type=script&lang=js&"
import style0 from "./studentWork.vue?vue&type=style&index=0&id=116335f2&prod&lang=less&scoped=true&"
import style1 from "./studentWork.vue?vue&type=style&index=1&id=116335f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116335f2",
  null
  
)

export default component.exports